import { breakPoints } from '@ovpn-ui/styles';
import { useMediaQuery } from '@ovpn-ui/utils';

export function useLayout() {
    const isTablet = useMediaQuery({ maxWidth: breakPoints.MD });
    const isMobile = useMediaQuery({ maxWidth: breakPoints.SM });

    return {
        isMobile,
        isTablet,
        isDesktop: !isMobile && !isTablet,
    };
}
export default useLayout;
